import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 4,
    height: 20,
    minWidth: 18,
    padding: '0 2px',
    border: '0.8px solid #27AE60',
    backgroundColor: 'var(--color-active-algo-show-bg)',
    color: '#27AE60',
    fontSize: '14px',
    lineHeight: '14.3px',
    fontWeight: 500,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',

    // eslint-disable-next-line no-useless-computed-key
    ['@media (min-width: 1300px)']: {
      top: 12,
      right: 12,
      position: 'absolute',
      height: 25,
      minWidth: 25,
      padding: '0 4px',
    },
  },
}));

const ActiveStrategy = ({ show, activeNo, className = '' }) => {
  const classes = useStyles();

  return (
    <>
      {show && <div className={`${classes.root} ${className}`}>{activeNo}</div>}
    </>
  );
};

export default ActiveStrategy;
